/** Workspace API — Faz 1.4 createApi factory. */
import {createApi} from './_factory'
import type {CommonNs, ProductNs, ProjectNs, WorkspaceNs} from '@shared/types'

const api = createApi('workspace')

export const WorkspaceApi = {
  getWorkspaceList: () =>
    api.get<WorkspaceNs.Workspace[]>('get-from-user'),
  getWorkspace: (workspaceId: string) =>
    api.get<WorkspaceNs.Workspace>(workspaceId),
  sendDeleteWorkspaceMail: (data: WorkspaceNs.WorkspaceActionRequest) =>
    api.post<WorkspaceNs.WorkspaceActionRequest, CommonNs.AnyResponse>('send-delete-workspace-mail', data),
  confirmDeleteWorkspace: (data: WorkspaceNs.ConfirmWorkspaceActionRequest) =>
    api.post<WorkspaceNs.ConfirmWorkspaceActionRequest, CommonNs.AnyResponse>('confirm-delete-workspace', data),
  leftWorkspace: (data: WorkspaceNs.WorkspaceActionRequest) =>
    api.post<WorkspaceNs.WorkspaceActionRequest, CommonNs.AnyResponse>('left-workspace', data),
  getCurrentProduct: () =>
    api.post<void, ProductNs.Product>('get-current-product'),
  sendUpgradeRequest: (data: ProjectNs.GenericProjectRequest) =>
    api.post<ProjectNs.GenericProjectRequest, CommonNs.AnyResponse>('request-upgrade', data),
}
